import { combineReducers } from 'redux';

import { reducer as listReducer } from './listModule';
import { reducer as detailsReducer } from './detailsModule';

export default combineReducers({
	details: detailsReducer,
	list: listReducer,
});
